import React, { Component } from "react";
import { Button, Grid, Header, Image } from "semantic-ui-react";

import LANDING_IMAGE from "../assets/images/pick_place_bot.jpg";

import * as CONSTANTS from "../assets/Constants";
import * as LINKS from "../assets/Links";

class AboutUs extends Component {

  render() {
    return (
        <Grid container columns="equal" stackable verticalAlign="middle">
        <Grid.Row>
          <Grid.Column>
            <div id="about">
              <Header as="h3" style={{ fontSize: "2em" }}>
                About Us
              </Header>
            </div>
            <p style={{ fontSize: "1.3em" }}>{CONSTANTS.ABOUT_US_PARA_1}</p>
            <p style={{ fontSize: "1.3em" }}>{CONSTANTS.ABOUT_US_PARA_2}</p>
          </Grid.Column>
          <Grid.Column floated="right" textAlign="center">
            <Image centered rounded size="large" src={LANDING_IMAGE} />
            <br />
            <br />
            <Button as="a" href='#/projects' target="_blank" rel="noopener noreferrer" size="huge">
              Check Out Our Projects
            </Button>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default AboutUs;
